import _ from 'lodash';
import React, {useEffect, useState} from "react";
import {NavHashLink, HashLink} from 'react-router-hash-link';
import {useNavigate, useMatch, NavLink} from "react-router-dom";
import { useTranslation, initReactI18next } from "react-i18next";
import {push as Menu} from 'react-burger-menu';
import classNames from "classnames";
import useMediaQuery from "../hooks/useMediaQuery";
import {Button} from "./Button";
import {NarBarBackButtonPrefersLogo, SubchainMainWebsite, SubchainMainWebsiteName} from "../constants";
import leftArrow from "../assets/icons/arrows/left@2x.png";
import brandLogo from "../assets/logos/grovewars@2x.png";

export const Navbar = ({}) => {
    const { t, i18n } = useTranslation();

    return (
        <div className={'Navbar'}>
            <React.Fragment>
                <div className={'Navbar__content'}>
                    <a className={'NavbarBackButton'}
                       href={SubchainMainWebsite}
                    >
                        <img src={leftArrow} className={'NavbarBackButton__arrow'}/>
                        {
                            NarBarBackButtonPrefersLogo &&
                            <img src={brandLogo} className={'NavbarBackButton__logo'}/>
                        }
                        {
                            !NarBarBackButtonPrefersLogo &&
                            <span>{SubchainMainWebsiteName}</span>
                        }
                    </a>
                    <NavLink to={'/claim'}
                             className={({isActive}) => {
                                 return classNames('Button Button--brand', {
                                     'hide': isActive
                                 })
                             }}
                             style={{marginLeft: "auto"}}

                    >
                        Burn & Claim
                    </NavLink>
                    <NavLink to={'/'}
                             className={({isActive}) => {
                                 return classNames('Button Button--brand', {
                                     'hide': isActive
                                 })
                             }}
                             style={{marginLeft: "auto"}}

                    >
                        Stake
                    </NavLink>
                </div>
            </React.Fragment>
        </div>
    )
}
